export const MAX_PARTITIONS_TO_CHECK: number = 5

export const PARTITION_DESCRIPTIONS_COMMON_DEVICES_PARTITION: string = '[Common Devices Partition]'
